import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { MainPageProps } from 'src/pages/MainPage'
import { memo } from 'react'
import { Typography } from 'src/components/common/Typography'
import { Noto_body2_r14, Noto_body3_r12, Noto_heading3_b20 } from 'src/styles/fonts/NotoSansKrFonts'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import React from 'react'
import { Roboto_num2_b16, Roboto_num4_r12 } from 'src/styles/fonts/RobotoFonts'
import LazyImage from 'src/components/common/LazyImage'
import usePageNav from 'src/hooks/usePageNav.hook'
import RenderIf from 'src/components/common/RenderIf'
import Skeleton from 'react-loading-skeleton'
const MainMdPickCoupon = memo(({ mdPickCouponList }: Pick<MainPageProps, 'mdPickCouponList'>) => {
  const { alwaysCouponDetailPageNav } = usePageNav()
  return (
    <S.MainMdPickContainer $option="flex_column" $row_gap="50px">
      {mdPickCouponList?.map(({ Coupons, Title, Contents }, m_i: number) => (
        <S.MainMdContents.Container $option="flex_column" key={m_i}>
          <S.MainMdContents.Title
            $fontStyle={Noto_heading3_b20}
            $color="var(--black-90)"
            as={!!Title ? Typography : Skeleton}
          >
            {Title}
          </S.MainMdContents.Title>
          <S.MainMdContents.Desc
            $fontStyle={Noto_body2_r14}
            $color="var(--black-50)"
            as={!!Contents ? Typography : Skeleton}
          >
            {Contents}
          </S.MainMdContents.Desc>
          <S.MainMdContents.CouponList>
            {Coupons?.map(
              (
                {
                  CouponName,
                  CouponImage,
                  DiscountRate,
                  SalePrice,
                  RegularPrice,
                  CouponNumber,
                  CouponIdx,
                },
                c_i: number,
              ) => (
                <S.MainMdContents.CouponItems.Container
                  key={c_i}
                  onClick={() => alwaysCouponDetailPageNav(`${CouponNumber}`, CouponIdx)}
                >
                  <S.MainMdContents.CouponItems.ImageWrap>
                    <LazyImage
                      src={CouponImage}
                      alt="쿠폰이미지"
                      style={S.MainMdContents.CouponItems.Image}
                    />
                  </S.MainMdContents.CouponItems.ImageWrap>
                  <RenderIf when={!SalePrice}>
                    <Skeleton count={2} style={{ marginBottom: '5px' }} />
                  </RenderIf>
                  <RenderIf when={!!SalePrice}>
                    <Container $option="flex_row" $column_gap="4px">
                      <S.MainMdContents.CouponItems.DiscountRate
                        $fontStyle={Roboto_num2_b16}
                        $color="var(--brand-50)"
                      >
                        {DiscountRate}%
                      </S.MainMdContents.CouponItems.DiscountRate>
                      <S.MainMdContents.CouponItems.RegularPrice
                        $fontStyle={Roboto_num2_b16}
                        $color="var(--black-90)"
                      >
                        {SalePrice?.toLocaleString() || 0}원
                      </S.MainMdContents.CouponItems.RegularPrice>
                    </Container>
                    <S.MainMdContents.CouponItems.SalePrice
                      $fontStyle={Roboto_num4_r12}
                      $color="var(--black-30)"
                    >
                      {RegularPrice?.toLocaleString()}원
                    </S.MainMdContents.CouponItems.SalePrice>
                    <S.MainMdContents.CouponItems.CouponName
                      $fontStyle={Noto_body3_r12}
                      $color="var(--black-90)"
                    >
                      {CouponName}
                    </S.MainMdContents.CouponItems.CouponName>
                  </RenderIf>
                </S.MainMdContents.CouponItems.Container>
              ),
            )}
          </S.MainMdContents.CouponList>
        </S.MainMdContents.Container>
      ))}
    </S.MainMdPickContainer>
  )
})
export default MainMdPickCoupon

const S = {
  MainMdPickContainer: styled(Container)`
    padding: 0 0 20px 0;
    background: var(--white);
    max-width: 420px;
    ${mediaMaxWidth('460')} {
      max-width: unset;
      padding: 0 20px;
    }
  `,
  MainMdContents: {
    Container: styled(Container)``,
    Title: styled(Typography)`
      margin-bottom: 1px;
    `,
    Desc: styled(Typography)`
      margin-bottom: 14px;
    `,
    CouponList: styled(Container)`
      display: grid;
      width: 100%;
      grid-template-columns: repeat(3, 135px);
      justify-content: space-between;
      row-gap: 20px;

      ${mediaMaxWidth('460')} {
        grid-template-columns: repeat(2, minmax(135px, 1fr));
        column-gap: 10px;
      }
    `,
    CouponItems: {
      Container: styled.section`
        width: 100%;
        height: fit-content;
        display: flex;
        flex-direction: column;
      `,
      ImageWrap: styled(Container)`
        position: relative;
        height: 0;
        padding-bottom: 100%;
        margin-bottom: 8px;
      `,
      Image: css`
        position: absolute;
        top: 0;
        transition: all 0.2s linear;
        display: flex;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        background-color: var(--white);
        padding: 10px;
        cursor: pointer;
        > img {
          border-radius: inherit;
        }
        @media (hover: hover) {
          &:hover {
            transform: scale(1.05);
          }
        }
      `,
      DiscountRate: styled(Typography)``,
      RegularPrice: styled(Typography)``,
      SalePrice: styled(Typography)`
        margin-top: 2px;
        margin-bottom: 6px;
        text-decoration: line-through;
      `,
      CouponName: styled(Typography)`
        ${ellip('line1')};
      `,
    },
  },
}
